import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { Routes, RouterModule } from "@angular/router";

import { IonicModule } from "@ionic/angular";

import { AssetTransactionPage } from "./asset-transaction.page";

const routes: Routes = [
  {
    path: "",
    component: AssetTransactionPage,
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
  declarations: [AssetTransactionPage],
})
export class AssetTransactionPageModule {}
